import React, { useState } from "react";
import { LeadViewDetailsViewProps } from "./lead-view-details-view.props";
import LeadViewDetailsViewFullInfo from "./lead-view-details-view-full-info/lead-view-details-view-full-info";
import LeadViewEditViewFullInfo from "../lead-view-details-edit/lead-view-edit-view-full-info/lead-view-edit-view-full-info";
import { AlertComponent } from "../../../../../common/components";
import "./lead-view-details-view.scss";
import { AlertType } from "../../../../../utils/util-types";
import { ALERT_TYPE } from "../../../../../utils/constants";

const LeadViewDetailsView: React.FC<LeadViewDetailsViewProps> = ({
  leadDetails,
  setLoading,
  selectedLeadId,
  viewFullInfoOpen,
  setViewFullInfoOpen,
  uploadedImage,
  uploadedImageFile,
  removeImage,
  fetchLeadDetails,
  onLeadNameUpdate,
  resetImageUpload,
  handleFormSubmitError,
  disableLeadStatus,
  permissions,
  isMobile,
}) => {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<AlertType>(ALERT_TYPE.SUCCESS);

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleCancelUpdate = () => {
    setViewFullInfoOpen(false);
    fetchLeadDetails();
  };

  return (
    <div className="lead-list-view-details-view-box">
      {viewFullInfoOpen ? (
        <LeadViewEditViewFullInfo
          setViewFullInfoOpen={setViewFullInfoOpen}
          viewFullInfoOpen={viewFullInfoOpen}
          leadDetails={leadDetails}
          selectedLeadId={selectedLeadId}
          handleCancelUpdate={handleCancelUpdate}
          setAlertOpen={setAlertOpen}
          setAlertMessage={setAlertMessage}
          setAlertType={setAlertType}
          setLoading={setLoading}
          uploadedImage={uploadedImage}
          uploadedImageFile={uploadedImageFile}
          removeImage={removeImage}
          onLeadNameUpdate={onLeadNameUpdate}
          resetImageUpload={resetImageUpload}
          handleFormSubmitError={handleFormSubmitError}
          disableLeadStatus={disableLeadStatus}
          isMobile={isMobile}
        />
      ) : (
        <LeadViewDetailsViewFullInfo
          setViewFullInfoOpen={setViewFullInfoOpen}
          viewFullInfoOpen={viewFullInfoOpen}
          leadDetails={leadDetails}
          permissions={permissions}
          isMobile={isMobile}
        />
      )}
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
    </div>
  );
};

export default LeadViewDetailsView;
